import { FC } from "react";
import { AppButton } from "site/ui";
import { useQuizStore } from "store";
import styled from "styled-components";
import { IQuizMode, IQuizYear } from "utils/types";


const QuizContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  font-family: "Manrope", sans-serif;
`;

const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 213, 96, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
`;
const LightbulbIcon = styled.div`
  font-size: 24px;
  color: #ffd700;
`;
const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  text-align: center;
  margin: 0;
  font-family: "Manrope", sans-serif;
`;

const Description = styled.p`
  font-size: 14px;
  color: #6b7280;
  text-align: center;
  margin: 0;
  font-family: "Manrope", sans-serif;
`;
const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 16px;
`;

const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 8px;
  font-family: "Manrope", sans-serif;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #111827;
  background-color: #ffffff;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;

  &:focus {
    outline: none;
    border-color: #5575f7;
  }
`;
const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
const RadioOption = styled.div<{ selected?: boolean; premium?: boolean }>`
  padding: 16px;
  border-radius: 12px;
  background-color: ${(props) => (props.selected ? "#F3F7FF" : "#F9FAFB")};
  border: 1px solid ${(props) => (props.selected ? "#5575F7" : "#E5E7EB")};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  opacity: ${(props) => (props.premium && !props.selected ? 0.7 : 1)};
`;
const RadioLabel = styled.label`
  font-size: 14px;
  color: #111827;
  cursor: pointer;
`;

const RadioInput = styled.input`
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  margin: 0;
  position: relative;

  &:checked {
    border-color: #5575f7;
    background-color: #5575f7;

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: white;
    }
  }
`;
const PremiumBadge = styled.span`
  padding: 4px 8px;
  background-color: #f3f4f6;
  border-radius: 16px;
  font-size: 12px;
  color: #6b7280;
`;
export interface QuizLoadingState {
}
export const QuizLoadingState:FC<QuizLoadingState> = ({}) => {
    const { quiz, quizMode } = useQuizStore();
    return (
        <QuizContainer>
        <IconContainer>
            <LightbulbIcon>💡</LightbulbIcon>
        </IconContainer>

        <Title>Course quiz</Title>
        <Description>
            Test your knowledge! Choose a timed or untimed quiz and select a
            past question year to begin.
        </Description>

        <FormGroup>
            <FormLabel>Choose past question</FormLabel>
            <Select disabled>
            <option>{quiz?.quizYear}</option>
            </Select>
        </FormGroup>

        <FormGroup>
            <FormLabel>Quiz mode</FormLabel>
            <RadioGroup>
            <RadioOption
                selected={quizMode === "untimed"}
                onClick={() => {}}
            >
                <RadioLabel>Untimed quiz (without timer)</RadioLabel>
                <RadioInput
                type="radio"
                name="quizMode"
                checked={quizMode === "untimed"}
                readOnly
                />
            </RadioOption>

            <RadioOption selected={quizMode === "timed"} onClick={() => {}}>
                <RadioLabel>Timed quiz (with timer)</RadioLabel>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                    }}
                >
                    <PremiumBadge>Premium</PremiumBadge>
                    <RadioInput
                        type="radio"
                        name="quizMode"
                        checked={quizMode === "timed"}
                        readOnly
                    />
                </div>
            </RadioOption>
            </RadioGroup>
        </FormGroup>

        <AppButton variant="primary" disabled>
            Loading up your questions...
        </AppButton>
        </QuizContainer>
    );
}